<template>
    <div v-if="isLoading" class="loading-overlay"><p>Carregando dados...</p></div>
    <MensagemAlerta class="row-space" v-if="msg" :mensagem="msg" />

    <div class="form-edit-page">
        <div class="row row-space">
            <div class="form-item-char10">
                <label class="label-caption">Código</label>
                <div class="field-label field-label-end">{{ formatInteger(objEdicao.id) }}</div>
            </div>
            <div class="form-item-data">
                <label class="label-caption">Data</label>
                <input type="date" v-model="objEdicao.dtferiado" />
            </div>
            <div class="form-item">
                <label class="label-caption" for="nmferiado">Nome/Descrição</label>
                <input type="text" v-model="objEdicao.nmferiado" id="nmferiado" maxlength="80" v-uppercase />
            </div>
        </div>

        <div class="row row-space">
            <TipoFeriadoSelect class="form-item" v-model:tipoSelecionado="objEdicao.tipo" />
            <MunicipioSelect v-show="objEdicao.tipo==3" class="form-item" v-model:idSelecionado="objEdicao.idmunicipio" />
        </div>


        <div class="row-end">
            <button type="button" class="btn-confirm" @click="salvarDados">Salvar</button>
            <button type="button" class="btn-cancel" @click="cancelForm">Cancelar</button>
        </div>
    </div>
</template>

<script setup>
import { criarFeriado } from '@/models/feriado';
import { onMounted, ref } from 'vue';
import { formatInteger } from '@/funcoes/utils';
import { genericPut, getCadastroById } from '@/funcoes/api';
import { globalStore } from '@/globals';
import MensagemAlerta from '@/components/utils/MensagemAlerta.vue';
import MunicipioSelect from '@/components/selects/MunicipioSelect.vue';
import TipoFeriadoSelect from '@/components/selects/TipoFeriadoSelect.vue';

const emit = defineEmits(['close', 'save']);
const props = defineProps({idEdicao: {type: Number, default: 0}});

const isLoading = ref(false);
const msg = ref(null);
const objEdicao = ref(criarFeriado());

const cancelForm = () => {emit('close');}

const lerDados = async() => {
    try{
        isLoading.value = true;
        msg.value       = null;
        if (props.idEdicao > 0) {
            try{
                const req = await getCadastroById('feriado', props.idEdicao);
                Object.assign(objEdicao.value, req[0]);
            }catch (error){msg.value = error}
        }else{
            objEdicao.value.idep        = globalStore.idep;
            objEdicao.value.idlogin     = globalStore.idlogin;
        }
        objEdicao.value.idusuario       = globalStore.idusuario;
    } catch (error) {msg.value = error;
    }finally{isLoading.value=false;}
}


const salvarDados = async() => {
    if (!objEdicao.value.dtferiado || objEdicao.value.dtferiado.trim() === '') {msg.value='Informe a data do feriado'; return;}
    try {
        isLoading.value             = true;
        msg.value                   = null;
        // CORREÇÕES
        if (objEdicao.value.tipo != 3) objEdicao.value.idmunicipio = 0;

        const response              = await genericPut('/cad/feriado', objEdicao.value);
        if (response.bolok === 1){
            emit('save');
            emit('close');
        }else{
            msg.value = response.erro;
        }
    } catch (error) {msg.value = error;
    } finally{isLoading.value=false;}
};

onMounted(lerDados);
</script>